
import { openLogoutUrl, platform } from 'platformImpl';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import history from '../../../history';
import './toolbar.css';
import { consultarNotificacoes } from 'apps/notificacao/actions';
import { formatarCpf } from 'shared/helper/formatadores';
import { abrirGovbr, deslogarUsuario } from 'login/actions';
import { removeNotificationToken } from 'apps/notificacao/registroNotificacao';

const UserInfo = ({
  notifications,
}) => {

  const dispatch = useDispatch()
  const usuario = useSelector(state => state.session.usuario);
  const pessoaCnis = useSelector(state => state.session.pessoaCnis);
  const inNomeSocial = useSelector(state => state.config?.inNomeSocial);
  const fotoBeneficiario = useSelector(state => state.carteira.foto);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const nomeExibicao = useMemo(() => {
    if (inNomeSocial && pessoaCnis && pessoaCnis.nomeSocial) {
      return pessoaCnis.nomeSocial
    }

    return (usuario && usuario.nome) ? usuario.nome.toLowerCase() : "";
  }, [usuario, inNomeSocial, pessoaCnis]);

  const userInfo = useMemo(() => {
    if(usuario.isProcurador) {
      return {
        name: getNomeProcurador(),
        cpf: usuario.cpfProcurador ? formatarCpf(usuario.cpfProcurador) : "",
        img: null
      }
    }
    return {
      name: nomeExibicao,
      cpf: usuario.cpf ? formatarCpf(usuario.cpf) : "",
      img: fotoBeneficiario || null
    }
  }, [usuario, nomeExibicao, fotoBeneficiario]);

  const { name, cpf, img } = userInfo;

  function getNomeProcurador(){
    return (usuario.nomeProcurador ? usuario.nomeProcurador.toLowerCase() : "");
  }

  const handleUserOptionClick = (rota) => {
    history.push(rota)
  }

  const userOptions = useMemo(() => {
    let options = [
      {
        id: "nome-exibicao",
        label: "Nome de Exibição",
        ariaLabel: "Alterar nome de exibição",
        action: () => handleUserOptionClick("/dados-cadastrais/nome-social"),
        icon: "fas fa-user-edit"
      },
      {
        id: "notificacoes",
        label: "Notificações",
        ariaLabel: "Acessar notificações",
        action: () => { dispatch(consultarNotificacoes()); handleUserOptionClick("/configuracoes/notificacoes-perfil"); },
        icon: "fas fa-bell"
      },
      {
        label: "Aparência da Tela",
        ariaLabel: "Alterar aparência da tela",
        action: () => handleUserOptionClick("/configuracoes/aparencia"),
        icon: "fas fa-adjust"
      },
     /* {
        label: "Libras",
        action: () => handleUserOptionClick("/configuracoes/libras"),
        icon: "fas fa-sign-language"
      },*/
      {
        label: "Tamanho da Fonte",
        ariaLabel: "Alterar tamanho da fonte",
        action: () => handleUserOptionClick("/configuracoes/tamanho-fonte"),
        icon: "fas fa-font"
      },
      {
        label: "Ajuda",
        ariaLabel: "Acessar ajuda",
        action: () => handleUserOptionClick("/configuracoes/ajuda"),
        icon: "fas fa-question-circle"
      }
    ]

    if (platform.isCordova) {
      options.push({
        label: "Biometria",
        action: () => handleUserOptionClick("/configuracoes/biometria"),
        icon: "fas fa-fingerprint"
      })
    }

    return options;
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  }

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const logoutAction = () => {
    localStorage.removeItem('ifs_auth');
    localStorage.removeItem('ifs_ts');
    sessionStorage.removeItem('initTrack');
    removeNotificationToken();
    openLogoutUrl();
  }

  const getShowName = () => {
    let nameArray = name ? name.trim().split(" ") : [];
    if (nameArray.length > 1) {
      return `${nameArray[0][0]}${nameArray[1][0]}`
    } else {
      return `${nameArray[0][0]}`
    }
  }

  const renderContent = () => {
    if (img) {
      return (
        <img src={img} alt="Avatar" />
      )
    } else if (name && name.length > 0) {
      return (
        <>{getShowName(name)}</>
      )
    } else {
      return (
        <i className="fas fa-user" aria-hidden="true"></i>
      )
    }
  }

  const trocarPerfilProcurador = () => {
    return abrirGovbr();
  }


  return (<>
    <div className="user-info-divider"></div>
    <div ref={dropdownRef} >
      <button
        className='btn-avatar br-button'
        type="button"
        id="avatar-dropdown-trigger"
        onClick={toggleDropdown}
        aria-expanded={isDropdownOpen}
        aria-controls='avatar-menu'
        aria-labelledby='avatar-dropdown-label'
      >
        <div className='br-avatar' title={name}>
          <div className="content text-pure-0 bg-avatar">
            {renderContent()}
          </div>
        </div>
        <i className={`fas ${isDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true"></i>
        <span id='avatar-dropdown-label' className='sr-only'>Abrir menu do perfil</span>
      </button>
      <div className={`br-list avatar-dropdown-options ${isDropdownOpen ? 'active' : ''}`} id="avatar-menu" role="menu" aria-labelledby="avatar-dropdown-trigger">
        <div key={"user-infos"} tabIndex={0} className="br-item d-flex align-items-center" role="menuitem">
          <button tabIndex={-1} className='btn-avatar br-button' type="button">
            <div className='br-avatar' title={name}>
              <div className="content text-pure-0 bg-avatar">
                {renderContent()}
              </div>
            </div>
          </button>
          <div>            
            <span className='user-name'>{name}</span><br />
            <span className='user-cpf'>{`CPF: ${cpf}`}</span>
          </div>
        </div>
        <span className='br-divider'></span>

        {
          userOptions.map((config, index) => {
            return <React.Fragment key={index + 1}>
              <div
                tabIndex={0}
                aria-label={`${config.ariaLabel}`}
                role="menuitem"
                className="br-item"
                onClick={() => {
                  config.action()
                  toggleDropdown()
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    config.action();
                    toggleDropdown();
                  }
                }}
              >
                <i className={`config-icon ${config.icon}`}></i>
                <a className="user-option-link">
                  {config.label}
                  {config.id === 'notificacoes' && notifications > 0 && <span className='notification-badge'>{notifications}</span>}
                </a>

                <i className="fas fa-chevron-right"></i>
              </div>
              {(index + 1) < userOptions.length && <span className='br-divider'></span>}
            </React.Fragment>
          })
        }
        {usuario && usuario.isProcurador &&
          <div key={"btn-trocar-perfil"} tabIndex={-1} className="br-item bg-button" role="menuitem">
            <button onClick={trocarPerfilProcurador} className='br-button primary block btn-icon' type="button">
              Trocar Perfil de Acesso
            </button>
          </div>
        }
        <div key={"btn-sair"} tabIndex={-1} className="br-item bg-button" role="menuitem">
          <button onClick={logoutAction} className='br-button secondary block btn-icon' type="button">
            <i className='fas fa-power-off'></i>Sair do Meu INSS
          </button>
        </div>
      </div>
    </div>
  </>)
}

export default UserInfo;